import React, { useState } from 'react';
import { Lock, Construction, ArrowRight, Star } from 'lucide-react';

export default function MaintenancePage({ maintenanceMode }) {
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === maintenanceMode.password) {
            sessionStorage.setItem('maintenance_bypass', 'true');
            window.location.reload();
        } else {
            setError(true);
            setTimeout(() => setError(false), 2000);
        }
    };

    return (
        <div className="min-h-screen bg-[#24574E] font-body text-[#F5F3EE] flex flex-col items-center justify-center p-6 text-center">
            <div className="max-w-2xl w-full">
                <div className="flex justify-center mb-12">
                    <div className="w-20 h-20 bg-[#F9D965] rounded-full flex items-center justify-center text-[#24574E] animate-pulse">
                        <Star size={40} fill="currentColor" />
                    </div>
                </div>

                <h1 className="text-6xl md:text-8xl mb-8 leading-[1.05]">
                    Maintenance <br /><span className="italic">en cours</span>
                </h1>

                <p className="text-xl text-[#F5F3EE]/60 mb-16 leading-relaxed font-medium max-w-lg mx-auto">
                    {maintenanceMode.message || "Nous préparons quelque chose de super pour votre association. Revenez dans quelques instants !"}
                </p>

                <div className="bg-white/5 border border-white/10 rounded-[4rem] p-16 backdrop-blur-lg max-w-md mx-auto">
                    <div className="flex justify-center mb-10">
                        <div className="w-16 h-16 rounded-full bg-[#5BC0AF]/20 text-[#5BC0AF] flex items-center justify-center">
                            <Construction size={32} />
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="relative">
                            <Lock className="absolute left-5 top-1/2 -translate-y-1/2 text-white/30" size={20} />
                            <input
                                type="password"
                                placeholder="Code d'accès..."
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={`w-full pl-14 pr-6 py-5 bg-white/5 border-2 ${error ? 'border-[#D3997F] bg-[#D3997F]/10' : 'border-white/10'} rounded-2xl focus:outline-none focus:border-[#F9D965] transition-all font-bold text-white placeholder:text-white/20`}
                            />
                        </div>
                        
                        <button
                            type="submit"
                            className="w-full bg-[#F9D965] text-[#24574E] py-5 rounded-2xl font-bold flex items-center justify-center gap-3 hover:scale-[1.02] transition-all group shadow-lg"
                        >
                            Accéder au site
                            <ArrowRight size={22} className="group-hover:translate-x-2 transition-transform" />
                        </button>

                        {error && (
                            <p className="text-[#D3997F] text-xs font-bold uppercase tracking-widest animate-bounce">
                                Code incorrect
                            </p>
                        )}
                    </form>
                </div>

                <p className="mt-20 text-white/20 text-xs font-bold uppercase tracking-[0.4em]">
                    &copy; {new Date().getFullYear()} SuperAsso <span className="text-[8px] opacity-40 px-1 border border-white/10 rounded ml-1">BETA</span> &bull; On revient vite !
                </p>
            </div>
        </div>
    );
}
